import { render, staticRenderFns } from "./DayLabelCalendar.vue?vue&type=template&id=2a60b636&scoped=true"
import script from "./DayLabelCalendar.vue?vue&type=script&lang=js"
export * from "./DayLabelCalendar.vue?vue&type=script&lang=js"
import style0 from "./DayLabelCalendar.vue?vue&type=style&index=0&id=2a60b636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60b636",
  null
  
)

export default component.exports